<template>
  <div id="login">
    <el-dialog
        :title="dialogTitle"
        :visible="loginDialog"
        :close-on-press-escape="false"
        width="330px"
        @close="closeDialog"
    >
      <el-form
          ref="loginForm"
          :model="form"
          :rules="formRules"
          class="login-form"
          v-loading="loading"
      >
        <el-form-item label="用户名" prop="username">
          <el-input :maxlength="16" v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input :maxlength="16" type="password" v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item v-if="dialogType === 'register'" label="确认密码" prop="confirmPassword">
          <el-input :maxlength="16" type="password" v-model="form.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-button round class="submit-btn" shape="circle" type="primary" @click="login">
          {{ dialogType === 'login' ? '登录' : '注册' }}
        </el-button>
        <div class="to-register">
          <template v-if="dialogType === 'login'">
            无账号，去
            <el-link type="primary" @click="switchLoginType">注册</el-link>
          </template>
          <template v-else>
            已有账号，去
            <el-link type="primary" @click="switchLoginType">登陆</el-link>
          </template>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {loginApi,registerApi} from "../api/login";
import CryptoJS from 'crypto-js'

const key = CryptoJS.enc.Utf8.parse('3618459473653728'); // 密钥为16位
const iv = CryptoJS.enc.Utf8.parse('3261845947365372'); // 偏移量为16位

export function encryptByAES(str) {
  const encrypted = CryptoJS.AES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

export default {
  name: 'login',
  computed: {
    loginDialog() {
      return this.$store.state.login.loginDialog
    },
    dialogType() {
      return this.$store.state.login.dialogType
    },
    dialogTitle() {
      return this.dialogType === 'login' ? '登录' : '注册'
    }
  },
  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      formRules: {
        username: [{required: true, message: '请输入用户名', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'register' && value.length < 6) {
                callback(new Error("请输入六位以上用户名"));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }],
        password: [{
          required: true, message: '请输入密码', trigger: 'blur'
        },
          {
            validator: (rule, value, callback) => {
              if (this.dialogType === 'register' && value.length < 6) {
                callback(new Error("请输入六位以上密码"))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }],
        confirmPassword: [
          {
            required: true,
            message: '请确认密码',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error('两次密码输入不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    switchLoginType() {
      let type = this.$store.state.login.dialogType;
      this.form.confirmPassword = '';
      this.$store.state.login.dialogType = type === 'login' ? 'register' : 'login';
    },
    closeDialog() {
      this.$store.dispatch('login/hideLoginDialog')
      this.$refs.loginForm.resetFields();
    },
    login() {
      const {username, password, confirmPassword} = this.form
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.dialogType === 'login') {
            loginApi({username,password: encryptByAES(password)}).then(res => {
              if (res.retCode === '0000'){
                localStorage.setItem('userinfo', JSON.stringify(res.data));
                this.$store.dispatch('login/setUserInfo', res.data);
                this.closeDialog();
                // this.$refs.mainNotice.showDialog()
                this.$message.success(res.retMsg);
              } else {
                this.$message.error(res.retMsg);
              }
            }).finally(()=>{
              this.loading = false;
            })
// 执行登录操作
          } else if (this.dialogType === 'register') {
            registerApi({username,password: encryptByAES(password)}).then(res => {
              if (res.retCode === '0000'){
                localStorage.setItem('userinfo', JSON.stringify(res.data));
                this.$store.dispatch('login/setUserInfo', res.data);
                this.closeDialog();
                this.$message.success(res.retMsg);
                // this.$refs.mainNotice.showDialog()
              } else {
                this.$message.error(res.retMsg);
              }
            }).finally(()=>{
              this.loading = false;
            })
          }
        }
      })
    }
  }
}

</script>
<style lang="less">
#login {
  .el-dialog {
    //z-index: 9999;
    border-radius: 15px;
    .el-dialog__title {
      font-weight: 600;
      font-size: 24px;
    }
  }

  .login-form {
    .el-form-item__label {
      text-align: left;
      width: 25%;
      white-space: nowrap;
    }

    .el-form-item__content {
      width: 75%;
      display: inline-block;
    }

    .submit-btn {
      width: 100%;
      margin-top: 20px;
    }

    .to-register {
      margin: 20px auto;
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/login.vue